import React, { useEffect, useState } from "react";
import { useParams } from "react-router-dom";
import { useTranslation } from "react-i18next";
import TransportOrderDetailView from "../components/transportOrderDetailModal/TransportOrderDetailView";
import { API_PublicLink_get, API_REQUEST_HEADERS_BASEURL } from "../utils/Constants";

const PublicOrder = () => {
  const { fleetId, transportOrderId, token } = useParams();
  const { t } = useTranslation();
  const [orderDetail, setOrderDetail] = useState(null);
  const [loading, setLoading] = useState(true);
  const [routeLayer, setRouteLayer] = useState([]);

  useEffect(() => {
    const fetchPublicOrder = async () => {
      try {
        const newAxios = API_REQUEST_HEADERS_BASEURL;

        const getEndpoint = API_PublicLink_get.replace("{fleetId}", fleetId)
          .replace("{transportOrderId}", transportOrderId)
          .replace("{token}", token);

        const response = await newAxios.get(getEndpoint);
        const data = response.data;

        if (!data.transportOrderId) {
          throw new Error(t("publicOrder.invalidLink", { defaultValue: "Invalid or expired link" }));
        }

        setOrderDetail(data);
        setRouteLayer(
          (data.checkPoints || []).map((p) => ({
            lat: parseFloat(p.latitude),
            lng: parseFloat(p.longitude),
          }))
        );

        const routeRes = await newAxios.get(
          `/fleets/${fleetId}/transportOrder/${transportOrderId}/actual-route`
        );
        const route = routeRes.data.route || [];

        if (route.length > 0) {
          const routePoints = route.map((p) => ({
            latitude: parseFloat(p.latitude),
            longitude: parseFloat(p.longitude),
          }));

          setRouteLayer(routePoints);
        }
      } catch (err) {
        console.error(err);
        setOrderDetail(null);
        setRouteLayer([]);
      } finally {
        setLoading(false);
      }
    };

    if (token && transportOrderId) fetchPublicOrder();
  }, [fleetId, transportOrderId, token, t]);

  if (loading) {
    return (
      <div className="public-order-page">
        <div className="public-content">
          <div className="content-wrapper">
            <p>{t("publicOrder.loading", { defaultValue: "Loading..." })}</p>
          </div>
        </div>
      </div>
    );
  }

  if (!orderDetail) {
    return (
      <div className="public-order-page">
        <div className="public-content">
          <div className="content-wrapper">
            <p>{t("publicOrder.invalidLink", { defaultValue: "Invalid or expired link" })}</p>
          </div>
        </div>
      </div>
    );
  }

  return (
    <TransportOrderDetailView orderDetail={orderDetail} routeLayer={routeLayer} publicMode={true} />
  );
};

export default PublicOrder;
